// extracted by mini-css-extract-plugin
export var listEvents = "video-module--list-events--cc3e3";
export var logoContainer = "video-module--logo-container--4d3d4";
export var videoPlayer = "video-module--video-player--fe693";